import React, {useContext} from 'react';
import PropTypes from 'prop-types';

// Material UI
import {Grid} from "@mui/material";

// Components
import Badge from "components/Badge";
import {WMSContext} from "../../../../../views/wms/context/WMSContext";

WmsItemCodes.propTypes = {
    wmsItem: PropTypes.object.isRequired,
};

function WmsItemCodes({wmsItem}) {
    const {currentOrganization} = useContext(WMSContext)

    if (!wmsItem || !wmsItem.lineItem) {
        return null;
    }

    return (
        <Grid
            item
            container
            style={{
                display: "flex",
                flexDirection: 'row',
                gap: '8px',
                overflow: "scroll",
                textWrap: "nowrap",
            }}
        >
            {currentOrganization?.wmsDisplayUgCode && (
                <Badge
                    rounded
                    color={"info"}
                    label={wmsItem.lineItem.variationSku}
                    isBold={false}
                    size={"large"}
                />
            )}
            <Badge
                rounded
                color={"info"}
                label={wmsItem.barcode}
                isBold={false}
                size={"large"}
            />
        </Grid>
    );
}

export default WmsItemCodes;
